import React from "react";
import _ from "lodash";

import logo from "assets/images/sbs/tot-new/tot-logo.png";
import clueGiver from "assets/images/sbs/tot-new/clue-giver.png";
import guesserBox from "assets/images/sbs/tot-new/guesser-box.png";

const ClueGiver = ({ mobile_app, currentGuesser, preguess_params }) => {
  const text_3 = _.get(
    preguess_params,
    "text_3",
    "When the round starts, help them guess as many words by giving clues about the word and press 'Got It!' if they get it!"
  );
  const text_4 = _.get(
    preguess_params,
    "text_4",
    "The round is about to start!"
  );
  const current_guesser = _.get(
    preguess_params,
    "current_guesser",
    "The Current Guesser is:"
  );
  return (
    <div className={`clue-giver ${mobile_app ? "mobile-cnt" : "web-cnt"}`}>
      <div className="clue-giver-div">
        <img src={logo} alt="logo" className="logo logo-tot" />
        <div className="text-center">
          <img src={clueGiver} alt="" className="cl-img" />
        </div>
        <div className="clue-giver-box">
          <p>{text_3}</p>
          <p>{text_4}</p>
        </div>
      </div>
      <div className="current-guesser">
        <h3 className="text">{current_guesser}</h3>
        <div className="guesser-img-cnt">
          <img
            src={currentGuesser?.profile_image}
            className="guesser-img"
            alt=""
          />
        </div>
        <div className="guesser-name">
          <img src={guesserBox} className="guesser-name-img" alt="" />
          <div className="name-cnt">
            <p
              className={`${
                currentGuesser?.display_name.length > 19 ? "name-small" : "name"
              }`}
            >
              {currentGuesser?.display_name}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClueGiver;
